import {
	MagnifyingGlassMinusIcon,
	MagnifyingGlassPlusIcon,
} from '@heroicons/react/20/solid';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import Modal from '../components/Shell/Modal';
import Bare from '../components/Shell/ShellBare';
import Button from '../components/Button';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFModal = ({ open, options, setClose, setOpen, children }) => {
	const [numPages, setNumPages] = useState(null);
	const [zoom, setZoom] = useState(1);

	const targetRef = useRef();
	const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

	useLayoutEffect(() => {
		if (targetRef.current) {
			setDimensions({
				width: targetRef.current.offsetWidth,
				height: targetRef.current.offsetHeight,
			});
		}
	}, []);

	return (
		<Modal
			showCloseIcon={false}
			size="full"
			name={'uploadContractPdfModal'}
			onClose={() => setClose()}
		>
			<Bare
				onBack={() => setClose()}
				backText={options?.backText || 'Close'}
				actions={options?.actions || []}
				contentProps={{ maxWidth: 'w-full' }}
				containerClassName="bg-gray-50"
			>
				<div className="grid grid-cols-12 gap-x-8">
					<div className="col-span-4">{children}</div>
					<div className="col-span-8 overflow-scroll">
						<Document
							file={options?.file || null}
							onLoadSuccess={({ numPages }) => setNumPages(numPages)}
							onLoadError={console.error}
							noData={
								<div className="bg-white w-full py-24 text-center text-xs text-gray-600">
									No data
								</div>
							}
						>
							{Array.apply(null, Array(numPages))
								.map((x, i) => i + 1)
								.map((page) => (
									<Page
										pageNumber={page}
										//width={dimensions.width * zoom}
										scale={1.5}
									/>
								))}
						</Document>
					</div>
				</div>
			</Bare>
		</Modal>
	);
};

export default PDFModal;
